/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Step SelectedDate styles
 *
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.10.0
 */

import styled from 'styled-components';

import { fonts } from '../../../../theme';

export const StepSelectDateStyled = styled.div.attrs({
    className: 'step-select-date',
})`
    display: flex;
    justify-content: space-between;
    margin-top: 32px;
`

export const StepSelectDateFilterWrapperStyled = styled.div`
    margin-bottom: 32px;
`

export const StepSelectDateInfoStyled = styled.div`
    max-width: 600px;
`

export const StepSelectDateFilterStyled = styled.div.attrs(() => ({
    className: 'step-select-date__filter',
}))`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    width: 600px;

    &:nth-child(2) {
        margin-top: 24px;
    }

    .select-container,
    .drop-down-filter__filter-button {
        height: 48px;
    }
`;

export const StepSelectDateLabelStyled = styled.div.attrs({
    className: 'step-select-date__label',
})`
     margin-bottom: 4px;
     ${fonts.textHeader5}
`
